import 'bootstrap';
import './styles/styles.scss';

import { createRoot } from 'react-dom/client';
import Routes from "./Routes";

const root = createRoot(document.getElementById('root'));
root.render(Routes);

// import React from 'react';
// import { createRoot } from 'react-dom/client';
// import { BrowserRouter, useRoutes } from "react-router-dom";
// import AppRoute from './config/app-route.jsx';

// import 'bootstrap';
// import './styles/styles.scss';

// const container = document.getElementById('root');
// const root = createRoot(container);
// function App() {
// 	let element = useRoutes(AppRoute);
	
// 	return element;
// }

// root.render(
// 	<BrowserRouter>
// 		<App />
// 	</BrowserRouter>
// );
